/**
 * AI Scribe V2 — column header
 *
 * The small uppercase strip that titles each of the three columns
 * (LIVE TRANSCRIPT / CLINICAL EVENTS / INSTRUCTIONS TO SCRIBE).
 *
 * @author [Rajkumar Rathod]
 */

import { ReactNode } from "react";
import Flex from "../../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../../components/Text";
import {
  PRIMITIVE,
  px,
} from "../../../../../../../../../../tokens/design-tokens";
import { SCRIBE_V2_COLORS, SCRIBE_V2_DIMENSIONS } from "../constants";

interface ScribePanelHeaderProps {
  icon: ReactNode;
  label: string;
  /** Optional right-aligned control, e.g. "PAUSE LISTENING" */
  action?: ReactNode;
}

const ScribePanelHeader = ({ icon, label, action }: ScribePanelHeaderProps) => (
  <Flex
    alignItems="center"
    justifyContent="space-between"
    gap={1}
    px={px(PRIMITIVE.spacing[12])}
    sx={{
      height: SCRIBE_V2_DIMENSIONS.panelHeaderHeight,
      flexShrink: 0,
      borderBottom: `1px solid ${SCRIBE_V2_COLORS.panelDivider}`,
    }}
  >
    <Flex alignItems="center" gap={0.75} sx={{ minWidth: 0 }}>
      <Flex
        alignItems="center"
        sx={{
          color: SCRIBE_V2_COLORS.panelLabel,
          "& svg": { fontSize: px(PRIMITIVE.spacing[16]) },
        }}
      >
        {icon}
      </Flex>
      <Text
        noWrap
        sx={{
          color: SCRIBE_V2_COLORS.panelLabel,
          fontSize: px(PRIMITIVE.typography.fontSize.body.b6),
          fontWeight: PRIMITIVE.typography.fontWeight.semiBold,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        }}
      >
        {label}
      </Text>
    </Flex>

    {action}
  </Flex>
);

export default ScribePanelHeader;
